import "./main.css";
import { useState, useEffect } from "react";
import AppNames from "./names/AppNames";
import AppMain from '../docket/main/AppMain';
import DocketLeft from "./main/docketLeft/DocketLeft";
import CloseSave from "../design/close";
import insertNames from "../../functions/insertNames";
import AppInovices from "./inovices/AppInovices";

import FetchMassage from "../../faetures/FetchMassage";
import Massage from "../design/Massage";
import { fetchPostDocket } from "../../faetures/fetch";


export default function Main({ setClose, num, dataDocket, setDataDocket }) {
    const [divHeight, setDivHeight] = useState('100%');
    const [reset, setReset] = useState(false); // When the docket changes, all the information will be reset.
    const [user, setUser] = useState();
    const [massage, setMassage] = useState({
        open: false, text: "", data: {}
    })
    const firstKey = Object.keys(dataDocket.names)[0];
    const firstName = dataDocket.names[firstKey];


    function InsertDataFromServer(dataFromServer) {
        // dataFromServer = dataFromServer["data"];

        if (dataFromServer instanceof Object) {

            if ('data' in dataFromServer) {
                dataFromServer = dataFromServer["data"];
            }

            const data_to_update = {
                num: dataFromServer.num,
                user: dataFromServer.user,
                date: dataFromServer.date,
                status: dataFromServer.status,
                name: dataFromServer.name,
                names: insertNames(dataFromServer['users']) || {},
                aufaFlights: dataFromServer['data_aufa'],
                aufaPaid: {},
                flights: {},
                accounts: dataFromServer['account'] || []
            };

            setDataDocket(data_to_update);
            setUser(data_to_update.user);
        }
    }

    const funResolve = (resolve) => {

        if (resolve[0] === 'okay') {
            InsertDataFromServer(resolve['data']);

            setMassage({ open: false });
        } else if (resolve[0] === 'valid') {
            setMassage({ open: true, text: "דוקט לא בבעלותך" });
        } else {
            setMassage({ open: false });
        }

        setReset(reset => !reset); // every change will reset the data.
    }

    useEffect(() => {
        const setDynamicHeight = () => {
            const windowHeight = window.innerHeight;
            const threePercentHeight = windowHeight * 0.03;

            if (threePercentHeight > 35) {
                setDivHeight('calc(100% - 3%)');
            } else {
                setDivHeight('calc(100% - 35px)');
            }
        };

        setDynamicHeight();
        window.addEventListener('resize', setDynamicHeight);

        return () => {
            window.removeEventListener('resize', setDynamicHeight);
        };
    }, []);

    useEffect(() => {
        /* In a new docket, when entering the first name, a new docket is created. */
        if (dataDocket.num === 0 && Object.keys(dataDocket.names).length) {
            fetchPostDocket('new-docket', { names: dataDocket.names }).then((resolve) => {
                InsertDataFromServer(resolve);
            })
        }
    }, [dataDocket.names])


    useEffect(() => {
        /* When entering the information of an existing docket number, it retrieves the docket's data; otherwise, it moves to a new docket.*/
        if (num && dataDocket['user'] === '') {
            setMassage({ open: true, text: "", data: { num: num } });
        }
    }, [num])

    return (<>
        <div className="screen-blurs" style={{ 'height': divHeight }}>
            <div className="docket main-docket">
                <div className="HeadDocketMain">
                    <CloseSave bc="rgba(1,1,1, 0)" hbc="rgba(128, 128, 128, 0.7)" setClose={setClose} />
                    <p> {dataDocket['num'] ? `דוקט מס'  - ${dataDocket['num']}` : 'דוקט חדש'} </p>
                </div>

                <AppMain
                    namesList={dataDocket.names}
                    num_of_docket={dataDocket.num}
                    aufaFlights={dataDocket.aufaFlights}
                    updateDataDocketList={(key, data) => {
                        setDataDocket({ ...dataDocket, [key]: [...dataDocket[key], data] });
                    }}
                    updateDataDocketObject={(key, data) => {
                        setDataDocket({ ...dataDocket, [key]: { ...dataDocket[key], ...data } });
                    }}
                    setCloseMain={setClose}
                />

                <div className="docketNames">
                    <AppNames
                        names={dataDocket.names}
                        setNames={(num, name) => setDataDocket({ ...dataDocket, names: { ...dataDocket.names, [num]: name } })}
                        setNamesAfterDelete={(names) => setDataDocket({ ...dataDocket, names: { ...names } })}
                        reset={reset}
                        setReset={setReset}
                        numOfDocket={dataDocket.num}
                    />
                </div>

                <div className="docketAccount">
                    <AppInovices data={dataDocket.accounts} user={user} userDetails={firstName} />
                </div>

                <div className="docket-left">
                    <DocketLeft data={dataDocket} setClose={setClose} />
                </div>

            </div>
        </div>

        {massage.open &&
            <FetchMassage
                url={'docket/get-docket'}
                data={massage.data}
                text={massage.text}
                fun={funResolve}
                setClose={() => setMassage({ ...massage, open: false })}
                setMassage={setMassage}
            />
        }
    </>)
}